import { render } from "./member-profile.vue?vue&type=template&id=29f6ea36&scoped=true&ts=true"
import script from "./member-profile.vue?vue&type=script&lang=ts"
export * from "./member-profile.vue?vue&type=script&lang=ts"

import "./member-profile.vue?vue&type=style&index=0&id=29f6ea36&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\tengxunshipin\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f6ea36"]])

export default __exports__